/* Cotto al Dente – movimenti e micro-interazioni (va con assets/cad-motion.css).
   Parte solo se <html> ha la classe cad-m (niente "riduci movimento", niente editor del tema).
   Nulla viene nascosto prima che questo script lo marchi: se lo script non carica, il sito resta com'era. */
(function () {
  'use strict';
  var d = document, h = d.documentElement;
  if (!h.classList.contains('cad-m') || window.__cadMotion) return;
  window.__cadMotion = true;

  var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
  var INTRO = 'main > .shopify-section:first-child :is(.cad-hero-text,.cad-pd-info,.cad-coll-head,.cad-gal)';
  var GROUPS = '.cad-head,.cad-hero-text,.cad-split-text,.cad-coll-head,.cad-paths,.cad-runs,.cad-shop,.cad-figs,' +
    '.cad-quotes,.cad-feats,.cad-steps,.cad-plans,.cad-cols,.cad-guides,.cad-checks,.cad-stats,.cad-mosaic,' +
    '.cad-faq,.cad-social,.cad-ct,.cad-trust';
  var SINGLES = '.cad-strip,.cad-upsell,.cad-preview,.cad-b2b,.cad-gal,.cad-pd-info';
  var SCALES = '.cad-hero-photo,.cad-split-photo,.cad-comm-photo,.cad-phones,.cad-hero-video';

  function each(sel, root, fn) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    header();
    var roots = d.querySelectorAll('.cad-home');
    if (!roots.length) return;
    var vh = window.innerHeight || 800;

    function visibleNow(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < vh * 0.92 && r.width > 0;
    }
    function markable(el) {
      if (!el || el.nodeType !== 1 || el.hasAttribute('data-cm')) return false;
      if (/^(SCRIPT|STYLE|TEMPLATE|LINK|INPUT|BR)$/.test(el.tagName)) return false;
      if (el.closest(INTRO)) return false;                       // già animati dal CSS all'apertura
      if (el.parentElement && el.parentElement.closest('[data-cm]')) return false; // il genitore si anima già
      if (visibleNow(el)) return false;                          // già a schermo: non lo nascondiamo
      return true;
    }

    var io = new IntersectionObserver(function (entries) {
      var batch = [];
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        (e.target.__cmItems || [e.target]).forEach(function (x) { if (batch.indexOf(x) < 0) batch.push(x); });
      });
      batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
      batch.forEach(function (el, i) {
        el.style.setProperty('--cm-d', Math.min(i * 0.075, 0.5).toFixed(3) + 's');
        el.classList.add('is-in');
        reveal(el);
        setTimeout(function () { el.style.removeProperty('--cm-d'); }, 2200);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(roots, function (root) {
      // gruppi: i figli entrano uno dopo l'altro
      each(GROUPS, root, function (g) {
        var kids = Array.prototype.filter.call(g.children, markable);
        if (!kids.length) return;
        kids.forEach(function (k) { k.setAttribute('data-cm', ''); });
        var cs = getComputedStyle(g);
        var hscroll = /(auto|scroll)/.test(cs.overflowX) && g.scrollWidth > g.clientWidth + 4;
        if (hscroll) { g.__cmItems = kids; io.observe(g); }      // caroselli su mobile: entrano insieme
        else kids.forEach(function (k) { io.observe(k); });
      });
      each(SCALES, root, function (el) { if (markable(el)) { el.setAttribute('data-cm', 'scale'); io.observe(el); } });
      each(SINGLES, root, function (el) { if (markable(el)) { el.setAttribute('data-cm', ''); io.observe(el); } });

      mocks(root);
      arrows(root);
      faq(root);
      lazyFade(root);
      gallery(root);
      if (fine) { parallax(root); tilt(root); }
    });
  });

  /* quando un elemento entra: numeri che contano */
  function reveal(el) {
    each('.cad-stat strong', el, countUp);
    if (el.matches && el.matches('.cad-stat strong')) countUp(el);
  }

  function countUp(el) {
    if (el.__cmCount) return; el.__cmCount = 1;
    var txt = el.textContent, m = txt.match(/^(\D*?)(\d[\d.,]*)(.*)$/);
    if (!m) return;
    var raw = m[2], dec = 0, thou = false, val;
    if (/,\d{1,2}$/.test(raw)) { dec = raw.split(',')[1].length; val = parseFloat(raw.replace(/\./g, '').replace(',', '.')); }
    else if (/\.\d{3}/.test(raw)) { thou = true; val = parseInt(raw.replace(/\./g, ''), 10); }
    else val = parseFloat(raw.replace(',', '.'));
    if (!isFinite(val) || val < 10 && !dec) return;
    var t0 = null, dur = 1500;
    function fmt(v) {
      var s = dec ? v.toFixed(dec).replace('.', ',') : String(Math.round(v));
      if (thou) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return m[1] + s + m[3];
    }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? fmt(val * e) : txt;
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = fmt(0);
    setTimeout(function () { requestAnimationFrame(step); }, 250);
  }

  /* illustrazioni della piattaforma: indici per la sequenza */
  function mocks(root) {
    each('.cad-mock', root, function (m) {
      ['.cad-bub', '.cad-mock-list li', '.cad-mock-food', '.cad-mock-row', '.cad-mock-tile',
       '.cad-mock-days span', '.cad-mock-opts span', '.cad-mock-mats span', '.cad-bar', '.cad-mock-prog i']
        .forEach(function (sel) { each(sel, m, function (x, i) { x.style.setProperty('--i', i); }); });
    });
  }

  /* frecce "→" che scivolano al passaggio */
  function arrows(root) {
    each('.cad-path-go,.cad-run-foot span,.cad-link,.cad-b2b a,.cad-actions a:not(.cad-btn)', root, function (el) {
      if (el.querySelector('.cm-arrow')) return;
      var w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
      while ((n = w.nextNode())) if (n.nodeValue.trim()) last = n;
      if (!last || !/→\s*$/.test(last.nodeValue)) return;
      var i = last.nodeValue.lastIndexOf('→');
      var after = last.splitText(i); after.splitText(1);
      var s = d.createElement('span'); s.className = 'cm-arrow'; s.setAttribute('aria-hidden', 'true');
      after.parentNode.insertBefore(s, after); s.appendChild(after);
    });
  }

  /* FAQ che si aprono e chiudono in modo fluido */
  function faq(root) {
    each('.cad-faq details', root, function (det) {
      var sum = det.querySelector('summary');
      if (!sum || det.__cm) return; det.__cm = 1;
      var acc = d.createElement('div'); acc.className = 'cm-acc';
      while (sum.nextSibling) acc.appendChild(sum.nextSibling);
      det.appendChild(acc);
      if (det.open) det.classList.add('cm-open');
      if (!acc.animate) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (det.__busy) return; det.__busy = 1;
        var opening = !det.open, anim, ended = false;
        function end() {                       // chiude lo stato anche se l'animazione non arriva in fondo
          if (ended) return; ended = true;
          if (anim) anim.cancel();
          if (!opening) det.open = false;
          det.__busy = 0;
        }
        if (opening) {
          det.open = true; det.classList.add('cm-open');
          var hh = acc.scrollHeight;
          anim = acc.animate([{ height: '0px', opacity: 0 }, { height: hh + 'px', opacity: 1 }],
            { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
        } else {
          det.classList.remove('cm-open');
          var h0 = acc.scrollHeight;
          anim = acc.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 320, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
        }
        anim.onfinish = end;
        setTimeout(end, 520);
      });
    });
  }

  /* immagini che compaiono in dissolvenza quando finiscono di caricare */
  function lazyFade(root) {
    each('img', root, function (img) {
      if (img.complete || img.closest(INTRO) || img.closest('.cad-hero-photo')) return;
      img.classList.add('cm-ld');
      var done = function () { img.classList.remove('cm-ld'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(function () { if (img.complete) done(); }, 4000);
    });
  }

  /* galleria prodotto: dissolvenza al cambio foto */
  function gallery(root) {
    each('.cad-gal-main img', root, function (img) {
      if (!window.MutationObserver || !img.animate) return;
      new MutationObserver(function () {
        img.animate([{ opacity: 0.25, transform: 'scale(1.015)' }, { opacity: 1, transform: 'scale(1)' }],
          { duration: 450, easing: 'cubic-bezier(.16,1,.3,1)' });
      }).observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    });
  }

  /* foto con leggero parallasse (solo desktop) */
  function parallax(root) {
    var items = [];
    each('.cad-hero-photo,.cad-split-photo,.cad-comm-photo', root, function (box) {
      var img = box.querySelector(':scope > img');
      if (img) { box.classList.add('cm-px'); items.push({ box: box, img: img }); }
    });
    if (!items.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      if (window.innerWidth < 990) { items.forEach(function (it) { it.img.style.removeProperty('--cm-py'); }); return; }
      items.forEach(function (it) {
        var r = it.box.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        it.img.style.setProperty('--cm-py', (-p * 3.2).toFixed(2));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* illustrazioni e telefoni che si inclinano leggermente seguendo il mouse */
  function tilt(root) {
    each('.cad-fig .cad-mock-card,.cad-phones', root, function (el) {
      var area = el.closest('.cad-fig') || el;
      el.classList.add('cm-tilt');
      area.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      area.addEventListener('pointerleave', function () {
        el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* header: ombra leggera quando si scorre */
  function header() {
    var on = false;
    function check() {
      var s = (window.scrollY || window.pageYOffset) > 8;
      if (s !== on) { on = s; h.classList.toggle('cm-scrolled', s); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
})();
